import { Dispatch } from 'redux';

import { getMyId } from 'src/utils/AuthHelperMethods';
import { changeDataSource } from 'src/actions/QueryActions';
import { callApi } from '../../services/api';

const updateMeApi = (id: string, body: any) =>
  callApi({ method: 'POST', endpoint: `/users/${id}/settings`, body });

export const updateDataSource = (dataSource: string, dispatch: Dispatch) => {
  const id = getMyId();
  const body = {
    key: 'DEFAULT_DATA_SOURCE',
    value: {
      data_source: dataSource,
    },
  };

  dispatch(changeDataSource(dataSource));
  updateMeApi(id, body);
};
